<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Új termék') }}</h1>

        <c-control-text class="mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="name" placeholder="Pipacs fehér 0,5kg" required
                        v-bind:invalid="!!requestStore.errors?.name"
                        v-bind:label="__('Megnevezés')"
                        v-model="product.name"
        />

        <c-control-text class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="abbreviation" placeholder="Pipacs fehér 0,5kg"
                        v-bind:invalid="!!requestStore.errors?.abbreviation"
                        v-bind:label="__('Rövidítés')"
                        v-model="product.abbreviation"
        />

        <c-control-text class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="description" type="textarea"
                        v-bind:invalid="!!requestStore.errors?.description"
                        v-bind:label="__('Leírás (összetevők)')"
                        v-bind:rows="2"
                        v-model="product.description"
        />

        <c-control-number class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="price_gross" placeholder="1000" required
                          v-bind:invalid="!!requestStore.errors?.price_gross"
                          v-bind:label="__('Ár (bruttó)')"
                          v-bind:min="1"
                          v-model="product.price_gross"
        />

        <c-control-number class="mt-8 mx-auto text-center w-96" class-field="!bg-slate-100 border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="price_net" disabled
                          v-bind:invalid="!!requestStore.errors?.price_net"
                          v-bind:label="__('Ár (nettó)')"
                          v-bind:min="1"
                          v-model="price_net"
        />

        <c-control-number class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="vat_pct" placeholder="18" required
                          v-bind:invalid="!!requestStore.errors?.vat_pct"
                          v-bind:label="__('ÁFA kulcs')"
                          v-bind:min="1"
                          v-model="product.vat_pct"
        />

        <c-control-file class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="picture" required
                        v-bind:invalid="!!requestStore.errors?.picture"
                        v-bind:filenames="filenames"
                        v-bind:label="__('Kép')"
                        v-model="files"
        />

        <img class="max-w-96 mt-2 mx-auto"
             v-bind:alt="product.name"
             v-bind:src="files[0]"
             v-if="files[0]"
        />

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
                  v-on:click="submit"
        >
            {{ __('Mentés') }}
        </c-button>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, ref } from 'vue';
    import {
        CButton,
        CControlFile,
        CControlNumber,
        CControlText,
    } from '@teamfurther/cinderblock';
    import ProductRepository from '../../repositories/ProductRepository';
    import { useRequestStore } from '../../stores/request';

    const price_net = computed(() => Math.round(product.value.price_gross / (1 + product.value.vat_pct / 100)));
    const files = ref([]);
    const filenames = ref([]);
    const product = ref({
        description: '',
        name: '',
        picture: '',
        price_gross: 0,
        vat_pct: 18,
    });
    const productRepository = new ProductRepository();
    const requestStore = useRequestStore();

    async function submit() {
        product.value.picture = files.value[0];

        product.value = await productRepository.store(product.value);
    }

    onMounted(() => {
        files.value = [product.value.picture];
    });
</script>
